import { faRightLeft } from "@fortawesome/pro-solid-svg-icons"
import { Button, FormControl, MenuItem, TextField, Typography } from "@mui/material"
import { IAgency, IShortAgency } from "agency/model"
import { translate } from "app/language/service"
import * as React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { Popup } from "ui/components/Popup"
import { changeAgency } from "user/tools/agency-change"

interface IChangeAgencyPopupProps {
  currentAgency: IAgency
  availableAgencies: IShortAgency[]
  onClose: () => any
}

export const ChangeAgencyPopup = React.memo(
  ({ currentAgency, availableAgencies, onClose }: IChangeAgencyPopupProps): JSX.Element => {
    const [selectedAgency, setSelectedAgency] = React.useState<IShortAgency | null>(null)
    return (
      <Popup
        icon={faRightLeft}
        id="change-agency-popup"
        title={translate("agency.change.button")}
        onClose={() => onClose()}>
        <FlexBox vertical gap wrap sx={{ p: "1rem" }}>
          <Typography color="textPrimary" fontSize=".9rem">
            {translate("agency.change.select.text")}
          </Typography>
          <FlexBox gap wrap>
            <FormControl sx={{ width: "15rem" }}>
              <TextField
                variant="outlined"
                select
                fullWidth
                size="small"
                label={translate("label.agency")}
                value={selectedAgency?.id}
                onChange={event => {
                  setSelectedAgency(availableAgencies.find(a => String(a.id) === String(event.target.value)))
                }}>
                {availableAgencies.map((a, index) => (
                  <MenuItem id={`agency-option-${index}`} key={index} value={a.id}>
                    {a.name || "-"}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
            <Button
              disabled={!selectedAgency}
              variant="outlined"
              onClick={() => changeAgency(selectedAgency as IShortAgency)}>
              {translate("label.change")}
            </Button>
          </FlexBox>
        </FlexBox>
      </Popup>
    )
  }
)
